
// START PROCODE Scripts

function serializeJSON(container, invisible = true) {
  const formData = new FormData(); // Create an empty FormData object
  const inputs = container.querySelectorAll("input, select, textarea"); // Get all inputs in the container
  const pairs = {};
  const consistent = {};

  inputs.forEach((input) => {
    if (input.name) {
      if ((input.type === "radio" || input.type == "checkbox") && !input.checked) return;
      formData.append(input.name, input.value); // Manually append each input to FormData
    }
  });

  if (invisible) {
    for (const [name, value] of formData) {
      if (value === null || value === "" || JSON.stringify(value) === "{}") {
        continue;
      } else if (name == "form_type" || name == "utf8") {
        consistent[name] = value;
      } else {
        pairs[name] = value;
      }
    }
  } else {
    const visibleInputs = Array.from(container.elements).filter(
      (e) => e.style.display !== "none"
    );
    for (var i = 0; i < visibleInputs.length; i++) {
      if (
        visibleInputs[i].value === null ||
        visibleInputs[i].value === "" ||
        JSON.stringify(visibleInputs[i].value) === "{}"
      ) {
        continue;
      } else if (
        visibleInputs[i].name == "form_type" ||
        visibleInputs[i].name == "utf8"
      ) {
        consistent[visibleInputs[i].name] = visibleInputs[i].value;
      } else {
        pairs[visibleInputs[i].name] = visibleInputs[i].value;
      }
    }
  }
  return JSON.stringify({ consistent, data: pairs }, null, 2);
}

function webhookHiderCheck(webhookSteps) {
  webhookSteps.forEach((step) => {
    if(step.hasAttribute("data-hide-next-previous") && step.dataset.hideNextPrevious === 'true') {
      const parentBlock = step.closest(".block--step");
      if (parentBlock) {
        const connectedStep = parentBlock.parentNode.nextElementSibling;
        if (connectedStep && connectedStep.classList.contains("steps")) {
          connectedStep.classList.add("hidden");
        }
      }
    }
  });
}

class FormBuilder extends HTMLElement {
  constructor() {
    super();
    this.form = document.querySelector("#pro-form");
    this.thanks = document.querySelector("#thanks");
    this.form_submit = document.getElementById("custom-form-submit");
    this.steps = this.form.querySelectorAll(".steps step-button");
    this.allSteps = this.form.querySelectorAll("step-button");
    this.webhookSteps = Array.from(this.allSteps).filter(
      (stepButton) => !Array.from(this.steps).includes(stepButton)
    )

    // for SHEER ID only
    this.sheerCheck = this.form.querySelectorAll('.next-step-blocker');
    // end SHEER ID only

    if (!this.form) return;

    this.form.addEventListener("submit", this.formSubmit.bind(this));

    this.querySelectorAll(".field__input-file").forEach((input) =>
      input.addEventListener("change", this.onFileInput.bind(this))
    );

    this.querySelectorAll('[data-autocomplete-response="true"]').forEach(
      (input) =>
        input.addEventListener("focusout", this.autocompleteResponse.bind(this))
    );

    // for SHEER ID only
    this.sheerCheck.forEach((link) => {
      link.addEventListener("click", this.sheerIdHandle.bind(this));
    });
    // end SHEER ID only

    webhookHiderCheck(this.webhookSteps);

    this.radios = this.form.querySelectorAll('input[type="radio"]');

    if (!this.radios) return;

    this.radios.forEach((radio) =>
      radio.addEventListener("change", this.conditionalCheck.bind(this))
    );
  }

  onFileInput(event) {
    const input = event.target;
    const file_link = input.nextElementSibling;
    if (input.files) {
      this.form_submit.classList.add("button--loading");
      this.form_submit.disabled = true;

      const customerEmail = this.form.querySelector('input[type="email"]');

      console.log('customerEmail',customerEmail);
      console.log('value',customerEmail.value);

      const file = input.files[0];
      const formData = new FormData();
      formData.append("email", customerEmail?.value);
      formData.append("file", file);
      formData.append("document", this.form_submit.dataset.source);

      var res = Array.from(formData.entries(), ([key, prop]) => ({
        [key]: {
          ContentLength: typeof prop === "string" ? prop.length : prop.size,
        },
      }));

      if (file.size > 10000000) {
        alert("File size too large, please reduce file size and resubmit");
        input.value = "";
      } else {
        console.log("input.dataset.sendTo", input.dataset.sendTo);
        fetch(input.dataset.sendTo, {
          method: "POST",
          body: formData,
        })
          .then((response) => response.text())
          .then((data) => {
            file_link.value = data;
            this.form_submit.classList.remove("button--loading");
            document.getElementById("custom-form-submit").disabled = false;
          })
          .catch((error) => {
            this.form_submit.classList.remove("button--loading");
            document.getElementById("custom-form-submit").disabled = false;
          });
      }
    }
  }

  autocompleteResponse(event) {
    if (!this.dataset.autocheck || !this.steps) return;

    const currentStep = this.form.querySelector(".block--step:not(.hidden)"); // Get the current step
    console.log('serializeJSON(currentStep ? currentStep : this.form)',serializeJSON(currentStep ? currentStep : this.form))

    const statusCheck = event.target.dataset.autoapproveStatuscheck;
    const statusCheckSkipTo = event.target.dataset.autoapproveSkipto;

    fetch(this.dataset.autocheck, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: serializeJSON(currentStep ? currentStep : this.form),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log('data response', data);
        if (data.autoapprove) {
          const fileUploadStepData = this.querySelector(
            '[data-file-upload="true"]'
          ).dataset;
          this.steps.forEach((step) => {
            const stepGoTo = step.getAttribute("data-step-goto");
            if (stepGoTo == fileUploadStepData.stepNo) {
              step.dataset.step == "back"
                ? step.setAttribute(
                    "data-step-goto",
                    parseInt(fileUploadStepData.stepNo) - 1
                  )
                : step.setAttribute(
                    "data-step-goto",
                    parseInt(fileUploadStepData.stepNo) + 1
                  );
            }
          });
        }
        if (statusCheck) {
          const statusCheckKey = statusCheck.split("::")[0];
          const statusCheckValue = statusCheck.split("::")[1];
          const statusCheckSkipTo = event.target.dataset.autoapproveSkipto;
        
          // Ensure data[statusCheckKey] is a string before comparison
          const keyExists = Object.prototype.hasOwnProperty.call(data, statusCheckKey);
          const keyValue = keyExists ? String(data[statusCheckKey]) : null;
        
          console.log("statusCheckKey:", statusCheckKey);
          console.log("statusCheckValue:", statusCheckValue);
          console.log("keyValue:", keyValue);
        
          if (keyExists && keyValue === statusCheckValue) {
            console.log("Key matches. Skipping to step:", statusCheckSkipTo);
          
            // Skip to the required step
            this.steps.forEach((step, index) => {
              const stepNo = parseInt(step.getAttribute("data-step-no"));
          
              if (stepNo === parseInt(statusCheckSkipTo)) {
                console.log("Step to skip is:", step);
          
                // Update the step AFTER the skipped step
                const nextStep = this.steps[index + 1];
                if (nextStep) {
                  nextStep.setAttribute("data-step-goto", stepNo - 1); // Back button points to the step before the skipped step
                  console.log("Updated next step's back button to:", stepNo - 1);
                }
          
                // Update the step BEFORE the skipped step
                const previousStep = this.steps[index - 1];
                if (previousStep) {
                  previousStep.setAttribute("data-step-goto", stepNo + 1); // Next button points to the step after the skipped step
                  console.log("Updated previous step's next button to:", stepNo + 1);
                }
              }
            });
          }
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  sheerIdHandle(event) {
    const href = event.target.getAttribute("href");

    if (href && !href.includes("services.sheerid.com")) {
      return;
    }

    event.preventDefault();

    sheerId.loadInModal(
      href, {
      mobileRedirect: true
    });
  }

  conditionalCheck(event) {
    const currentConditionals = event.target
      .closest("fieldset")
      .querySelectorAll('input[type="radio"]');

    Array.from(currentConditionals).forEach((radio) => {
      if (
        "conditionalConnected" in radio.dataset &&
        this.querySelector(
          `[data-connected="${radio.dataset.conditionalConnected}"]`
        )
      ) {
        this.querySelector(
          `[data-connected="${radio.dataset.conditionalConnected}"]`
        ).classList.add("hidden");
      }
    });

    if (event.target.dataset.conditionalConnected) {
      const conditionalEl = this.querySelector(
        `[data-connected="${event.target.dataset.conditionalConnected}"]`
      );
      if (conditionalEl) conditionalEl.classList.remove("hidden");
    }

    Array.from(this.steps).forEach((step) => {
      let previousSibling = step.previousElementSibling;
    
      // Loop through all previous siblings and hide those without the "data-step" attribute
      while (previousSibling) {
        if (!previousSibling.hasAttribute("data-step")) {
          previousSibling.classList.add("hidden");
        }
        previousSibling = previousSibling.previousElementSibling;
      }
    });

    const currentBlocker = event.target.hasAttribute("data-blockid");

    if (currentBlocker) {
      const blockerId = event.target.dataset.blockid;
    
      // Find the previousSibling of the step that has the matching data-blockid
      const blockerSibling = Array.from(this.steps).reduce((result, step) => {
        if (result) return result; // If a match is already found, stop further checks
    
        let previousSibling = step.previousElementSibling;
    
        // Loop through all previous siblings
        while (previousSibling) {
          if (
            previousSibling.getAttribute("data-blockid") === blockerId &&
            (!previousSibling.hasAttribute("data-block-connect") || previousSibling.dataset.blockConnect === event.target.value)
          ) {
            return previousSibling; // Return the matching previous sibling
          }
          previousSibling = previousSibling.previousElementSibling; // Move to the next previous sibling
        }
    
        return null; // No matching sibling found for this step
      }, null);
        
      // Perform actions based on the blockerSibling
      if (blockerSibling) {
        if (event.target.checked) {
          blockerSibling.classList.remove("hidden");
        } else {
          blockerSibling.classList.add("hidden");
        }
      }
    }

  }

  formSubmit(event) {
    event.preventDefault();
    console.log("this.dataset.send", this.dataset.send);
    console.log("serializeJSON(this.form)", serializeJSON(this.form));
    this.form_submit.classList.add("animate");
    let redirect_url;
    if (this.hasAttribute("data-redirect")) {
      redirect_url = this.dataset.redirect;
    }
    fetch(this.dataset.send, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: serializeJSON(this.form),
    })
      .then((response) => response.json())
      .then((data) => {
        this.form_submit.classList.remove("animate");
        this.form_submit.classList.add("success");
        setTimeout(
          function () {
            if (data.hasOwnProperty("success")) {
              this.form.classList.add("hidden");
              this.thanks.classList.remove("hidden");
              this.thanks.scrollIntoView();
              if (redirect_url) {
                setTimeout(function () {
                  window.location.href = redirect_url;
                }, 500);
              } else if (data.success == "domain") {
                this.thanks.querySelector(".domain").classList.remove("hidden");
              } else if (data.success == "procode") {
                this.thanks
                  .querySelector(".procode")
                  .classList.remove("hidden");
              } else {
                this.thanks
                  .querySelector(".default")
                  .classList.remove("hidden");
              }
            } else {
              var form_error = document.getElementById("form_error");
              if (!form_error) {
                form_error = document.createElement("div");
                form_error.id = "form_error";
                this.form_submit.parentNode.insertBefore(
                  form_error,
                  this.form_submit.nextSibling
                );
              }
              form_error.innerText = data.error;
            }
          }.bind(this),
          500
        );
      })
      .catch((error) => {
        console.error("Error:", error);
        this.form_submit.classList.remove("animate");
        this.form_submit.classList.add("error");
      });
  }
}
customElements.define("form-builder", FormBuilder);

class ApplyProcode extends HTMLElement {
  constructor() {
    super();
    this.procodeForm = document.getElementById("pro-code--form");
    this.container = document.getElementById("procode");
    this.thanks = document.getElementById("pro-code--thanks");

    this.procodeForm.addEventListener("submit", this.procodeCheck.bind(this));
  }

  procodeCheck(event) {
    event.preventDefault();
    const form = event.target;
    const form_submit = form.querySelector("button");
    let redirect_url;
    if (this.hasAttribute("data-redirect")) {
      redirect_url = this.dataset.redirect;
    }
    form_submit.disabled = true;
    form_submit.classList.add("button--loading");
    fetch("https://hook.us1.make.com/95l6jr5qki6y4c8rxlys1yrai2o7dw47", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: serializeJSON(form),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log('data is', data)
        form_submit.disabled = false;
        form_submit.classList.remove("button--loading");
        var form_error = document.getElementById("form_error");
        if (!form_error) {
          form_error = document.createElement("div");
          form_error.id = "form_error";
          form_submit.parentNode.insertBefore(
            form_error,
            form_submit.nextSibling
          );
        }
        if (data.success) {
          this.form.classList.add("hidden");
          this.thanks.classList.remove("hidden");
          this.thanks.scrollIntoView();
          if (redirect_url) {
            setTimeout(function () {
              window.location.href = redirect_url;
            }, 500);
          }
        } else {
          form_error.innerText = data.reason;
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
}

customElements.define("apply-procode", ApplyProcode);

String.prototype.imgURL = function (size) {
  return this.replace(/\.jpg|\.png|\.gif|\.jpeg/g, function (match) {
    return "_" + size + match;
  });
};

function errorMaker(el, errorMessage) {
  let form_error = el.nextElementSibling;
  if (!form_error || !form_error.classList.contains("form_error")) {
    form_error = document.createElement("div");
    form_error.classList.add("form_error");
    el.parentNode.insertBefore(form_error, el.nextSibling);
  }
  form_error.classList.add("error");
  form_error.innerText = errorMessage;
}

function validateEmail(email) {
  const regex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+")){1,64}@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regex.test(email);
}

function validateVisibleInputs(form) {
  const inputs = form.querySelectorAll("input");

  for (var i = 0; i < inputs.length; i++) {
    const label = form.querySelector(`label[for="${inputs[i].id}"]`);

    if (
      (!label && inputs[i].offsetParent === null) || 
      (label && inputs[i].offsetParent === null && label.offsetParent === null)
    ) {
      continue;
    }

    if (inputs[i].classList.contains("required")) {
      if (!inputs[i].value) {
        inputs[i].classList.add("input_error");
        throw new Error("Required input is empty");
      }

      if (inputs[i].type == "email" && !validateEmail(inputs[i].value)) {
        inputs[i].classList.add("input_error");
        throw new Error("The email is invalid");
      }

      if (inputs[i].type === "radio") {
        const radioGroup = form.querySelectorAll(
          `input[name="${inputs[i].name}"]`
        );
        const isChecked = Array.from(radioGroup).some((radio) => radio.checked);
        if (!isChecked) {
          const parentElement = inputs[i].parentElement;
          parentElement.classList.add("input_error");
          throw new Error("At least one option must be selected");
        }
      }
    }
  }

  return true;
}

class StepSubmit extends HTMLElement {
  constructor() {
    super();

    this.step = this.closest(".block--step");
    this.form = this.closest("form");
    this.steps = this.form.querySelectorAll(".steps step-button");
    this.allSteps = this.form.querySelectorAll("step-button");
    this.webhookSteps = Array.from(this.allSteps).filter(
      (stepButton) => !Array.from(this.steps).includes(stepButton)
    )

    this.addEventListener("click", this.nextStep.bind(this));
  }

  nextStep(event) {
    const dataAttributes = this.dataset;
    
    if(dataAttributes.step === 'back') {
      this.navigateToFormStep(dataAttributes.stepGoto);
      return;
    }
    
    Array.from(this.form.querySelectorAll("input")).forEach((el) =>
      el.classList.remove("input_error")
    );

    Array.from(this.form.querySelectorAll("fieldset")).forEach((el) =>
      el.classList.remove("input_error")
    );

    Array.from(this.form.querySelectorAll(".form_error")).forEach((el) =>
      el.classList.add("hidden")
    );

    try {
      validateVisibleInputs(this.form);
      
      this.checkForStepSkipper(this.form)

      if ("target" in dataAttributes) {
        this.formSubmission(
          dataAttributes.target,
          serializeJSON(this.form, false),
          event.target
        );
      } else {
        this.navigateToFormStep(dataAttributes.stepGoto);
      }
    } catch (err) {
      errorMaker(this, err);
    }
  }

  scrollToAction() {
    const mainContentEl = document.getElementById("page--proprogram");
    window.scrollTo({
      top: mainContentEl.offsetTop - 250,
      behavior: "smooth",
    });
  }

  checkForStepSkipper(form) {
  }

  navigateToFormStep(stepNumber) {
    this.closest(".steps").classList.add("hidden");

    const steps = this.form.querySelectorAll(".block--step");
    
    steps.forEach((formStepElement) => {
      formStepElement.classList.add("hidden");
    });

    this.form.querySelector(".contact__button").classList.add("hidden");

    if (steps.length == stepNumber) {
      this.form.querySelector(".contact__button").classList.remove("hidden");
    }

    const nextStep = Array.from(steps).filter((step) => {
      return step.getAttribute("data-step-no") === stepNumber;
    });
    
    if (nextStep.length > 0) {
      nextStep[0].classList.remove("hidden");
    
      const nextColumn = nextStep[0].closest(".col-60")?.nextElementSibling;
    
      if (nextColumn) {
        setTimeout(() => {
          nextColumn.classList.remove("hidden");
        }, 1);
      }
    
      webhookHiderCheck(this.webhookSteps);
    }

    this.scrollToAction();

    /*
    const stepsBtns = this.form.querySelectorAll('.steps');
    for (let i = 0; i < stepsBtns.length; i++) {
      const prevStep = stepsBtns[i].querySelector('[data-step="back"]') ?. getAttribute('data-step-goto') ?? 0;
      const nextStep = stepsBtns[i].querySelector('[data-step="forward"]') ?. getAttribute('data-step-goto') ?? 0;
      if (Number(prevStep) === (Number(stepNumber) + 1) || Number(nextStep) === (Number(stepNumber) + 1)) {
        stepsBtns[i].classList.remove('hidden');
        break;
      }
    }
    */
  }

  formSubmission(target, stepJSON, el) {
    const conditionalEls = this.step.querySelectorAll(
      `[data-connected="${this.dataset.conditionalConnected}"]`
    );

    fetch(target, {
      method: "POST",
      body: stepJSON,
    })
      .then((response) => response.json())
      .then((data) => {
        this.classList.add("hidden");

        // const stepsElement = this.step.closest(".col-60").nextElementSibling;
        // if (stepsElement && stepsElement.classList.contains("steps")) {
        //   stepsElement.querySelector('step-button').click;
        //   console.log('stepsElement');
        //   console.log(stepsElement);
        //   // stepsElement.classList.remove("hidden");
        // }

        const stepsElement = this.step.closest(".col-60").nextElementSibling;

        if (stepsElement && stepsElement.classList.contains("steps")) {
          const stepButton = stepsElement.querySelector("step-button");
          if (stepButton) {
            stepButton.click();
            console.log("stepsElement:", stepsElement);
          }
        }

        const nextElement = this.nextElementSibling;
        if (nextElement && nextElement.classList.contains("error")) {
          nextElement.classList.remove("hidden");
          nextElement.textContent = data.message;
        }

        if (!conditionalEls) return;
        const conditionalResponse = Array.from(conditionalEls).filter(
          (El) => El.getAttribute("data-connected-response") === data.response
        );
        if (conditionalResponse.length > 0)
          conditionalResponse[0].classList.remove("hidden");

        el.dataset.HideNextPrevious = "false";
      })
      .catch((error) => {
        console.log("error", error);
      });
  }
}

customElements.define("step-button", StepSubmit);
